export const compare = {
  Duplicate: "Duplicate",
} as const;
